










































import { Component, Watch, Vue } from 'vue-property-decorator';
import storage from '../utils/storage';
import moment from 'moment';
import Loading from '../components/Loading.vue';
import tableModel from '../components/table/tableModel.vue';
interface ArgsInter {
  name: string;
  asin: string;
  team: string;
  time: any;
  like: boolean;
}
@Component({
  components: {
    Loading,
    tableModel,
  },
})
export default class SearchOrderID extends Vue {
  private moment: any = moment;
  private user: any;
  private name: string = '';
  private asin: string = '';
  private dataJson: any = [];
  private beforeTime: any = moment(new Date()).subtract(4, 'months').format('YYYY-MM-DD');
  private afterTime: any = moment(new Date()).format('YYYY-MM-DD');
  private dateFormat = 'YYYY-MM-DD';
  private dateFormathms = 'YYYY-MM-DD HH:mm:ss';
  private dataTime: any = [this.beforeTime, this.afterTime];
  private switchLike: boolean = false;
  private spinning: boolean = false;
  private columns: any = [{
    title: 'orderID',
    dataIndex: 'orderID',
    width: '13%',
    scopedSlots: { customRender: 'orderID' },
  }, {
    title: 'ads',
    dataIndex: 'ads',
    width: '18%',
    scopedSlots: { customRender: 'ads' },
  }, {
    title: 'paymentsDate',
    dataIndex: 'paymentsDate',
    width: '15%',
    scopedSlots: { customRender: 'paymentsDate' },
  }, {
    title: 'buyerName',
    dataIndex: 'buyerName',
    width: '10%',
    scopedSlots: { customRender: 'buyerName' },
  }, {
    title: 'recipientName',
    dataIndex: 'recipientName',
    width: '10%',
    scopedSlots: { customRender: 'recipientName' },
  }, {
    title: 'account',
    dataIndex: 'kbAccount',
    width: '2%',
    scopedSlots: { customRender: 'kbAccount' },
  }, {
    title: 'webStar',
    dataIndex: 'rate',
    width: '2%',
    scopedSlots: { customRender: 'rate' },
  }, {
    title: 'webEmail',
    dataIndex: 'email',
    width: '10%',
    scopedSlots: { customRender: 'email' },
  }];
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      console.log('please login');
    } else {
     this.$router.push({
        path: '/login',
      });
    }
  }
  private onPickerChange(date: any, dateString: string) {
    // console.log(date, dateString);
    this.dataTime = dateString;
  }
  private getData(): any {
    if (!this.name || !this.asin) {
      this.$message.warning('Name or asin is not empty!!!');
      return false;
    }
    const that = this;
    this.spinning = true;
    const dataTime = [moment(this.dataTime[0]).format('YYYY-MM-DD HH:mm:ss'), this.dataTime[1] + ' 23:59:59'];
    const url = '/api/getSearchOrderID';
    const args: ArgsInter = {
      name: this.name,
      asin: this.asin,
      team: this.user.team,
      time: dataTime,
      like: this.switchLike,
    };
    this.axios.post(url, args).then((res: any) => {
      const data: any = res.data.data;
      data.forEach((item: any, index: number) => {
        data[index].ads = that.adsAdd(item);
      });
      that.dataJson = data;
      this.spinning = false;
    }).catch(() => {
      this.spinning = false;
    });
  }
  private adsAdd(item: any) {
    let ads = '';
    if (item.shipAddress2) {
      if (item.shipAddress3) {
        ads = item.shipAddress1 + '\r' + item.shipAddress2
            + '\r' + item.shipAddress3 + '\r' + item.shipCity + '\r'
            + item.shipState + '\r' + item.shipCountry + '\r' + item.shipPostalCode;
      } else {
        ads = item.shipAddress1 + '\r' + item.shipAddress2
            + '\r' + item.shipCity + '\r'
            + item.shipState + '\r' + item.shipCountry + '\r' + item.shipPostalCode;
      }
    } else {
      ads = item.shipAddress1 + '\r' + item.shipCity + '\r'
            + item.shipState + '\r' + item.shipCountry + '\r' + item.shipPostalCode;
    }
    return ads;
  }
  private emitEmptyName(): void {
    const inputBox: HTMLInputElement = this.$refs.NameInput as HTMLInputElement;
    inputBox.focus();
    this.name = '';
  }
  private emitEmptyAsin(): void {
    const inputBox: HTMLInputElement = this.$refs.asinInput as HTMLInputElement;
    inputBox.focus();
    this.asin = '';
  }
  private getCurrentStyle(current: any, today: any): any {
    const style: any = {};
    if (current.date() === 1) {
      style.border = '1px solid #1890ff';
      style.borderRadius = '50%';
    }
    return style;
  }
}

